module.exports = __webpack_public_path__ + "img/gitlab.577e3793.svg";